import { render } from "./CircleIcon.vue?vue&type=template&id=35ed77cd"
import script from "./CircleIcon.vue?vue&type=script&lang=js"
export * from "./CircleIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__